/**
 * Sound Toggle Button
 * Toggle sound effects on/off (voice is disabled)
 */

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { soundManager } from '../../lib/soundManager';

export function VoiceEnableButton() {
  const [soundEnabled, setSoundEnabled] = useState(() => soundManager.isSoundEnabled());
  const [isInitialized, setIsInitialized] = useState(false);

  const handleToggleSound = async () => {
    // Initialize audio context on first interaction (required for mobile)
    if (!isInitialized) {
      console.log('🔊 Initializing audio context...');
      await soundManager.playSparkle();
      setIsInitialized(true);
      // Small delay to ensure audio context is ready
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    const newState = soundManager.toggleSound();
    setSoundEnabled(newState);

    // Play a test sound when enabling
    if (newState) {
      await soundManager.playHop();
      console.log('🔊 Sound test played');
    }
  };

  // Don't auto-initialize sound - wait for user interaction
  useEffect(() => {
    console.log('🔊 Sound button mounted, waiting for user interaction');
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className="fixed top-[96px] md:top-[140px] left-4 sm:left-6 md:left-10 z-50"
    >
      <motion.button
        onClick={handleToggleSound}
        className={`px-4 py-3 sm:px-6 sm:py-3 rounded-full font-bold shadow-lg transition-all flex items-center gap-2 ${
          soundEnabled
            ? 'bg-green-500 text-white'
            : 'bg-gray-400 text-white'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <span className="text-3xl sm:text-4xl">{soundEnabled ? '🔊' : '🔇'}</span>
        <div className="text-lg sm:text-2xl font-semibold">
          {soundEnabled ? 'Sound On' : 'Sound Off'}
        </div>
      </motion.button>
    </motion.div>
  );
}
